import { gateway } from "src/gateway";

export type UpdateJobEventWorkforcePayload = {
  workforceUid: string | number;
  jobWorkforceRole: "supervisor" | "employee" | "contractor";
};

type UpdateJobEventWorkforceParams = {
  jobEventUid: string;
  workforce: UpdateJobEventWorkforcePayload[];
  expectedJobUpdatedAt?: string;
};

type UpdateJobDefaultWorkforceParams = {
  jobId: number;
  workforce: UpdateJobEventWorkforcePayload[];
  applyToEvents?: boolean;
  expectedJobUpdatedAt?: string;
};

export type BulkUpdateJobEventWorkforcePayload = {
  uid: string;
  role: "supervisor" | "employee" | "contractor";
};

export type BulkUpdateJobEventsParams = {
  jobId: number;
  eventUids?: string[];
  startDate?: string;
  workforces: BulkUpdateJobEventWorkforcePayload[];
  expectedJobUpdatedAt?: string;
};

export const updateJobEventWorkforce = async ({ jobEventUid, workforce, expectedJobUpdatedAt }: UpdateJobEventWorkforceParams) => {
  const token = sessionStorage.getItem("token");

  const response = await gateway.patch(
    `/jobs/event/${jobEventUid}/workforce`,
    { workforce, expectedJobUpdatedAt },
    {
      headers: {
        Authorization: token,
      },
    },
  );

  return response.data;
};

export const updateJobDefaultWorkforce = async ({ jobId, workforce, applyToEvents = true, expectedJobUpdatedAt }: UpdateJobDefaultWorkforceParams) => {
  const token = sessionStorage.getItem("token");

  const response = await gateway.patch(
    `/jobs/${jobId}/default-workforce`,
    {
      workforce,
      applyToEvents,
      expectedJobUpdatedAt,
    },
    {
      headers: {
        Authorization: token,
      },
    },
  );

  return response.data;
};

export const bulkUpdateJobEventsWorkforce = async ({ jobId, eventUids, startDate, workforces, expectedJobUpdatedAt }: BulkUpdateJobEventsParams) => {
  const token = sessionStorage.getItem("token");

  const response = await gateway.patch(
    "/jobs/bulk-events",
    {
      jobId,
      eventUids,
      startDate,
      workforces,
      expectedJobUpdatedAt,
    },
    {
      headers: {
        Authorization: token,
      },
    },
  );

  return response.data;
};
